export default function Worker_fn() {
  return new Worker(
    __webpack_public_path__ + "static/js/backboneWorker.353ebd48.worker.js"
  );
}
